export const stickerHydration = {
    keyMapping: {
        _id: "id",
        creator_id: "creatorId",
    },
    functions: {
        id: (sticker) => sticker._id,
        parent: (sticker) => sticker.parent,
        creatorId: (sticker) => sticker.creator_id,
        name: (sticker) => sticker.name,
        nsfw: (sticker) => sticker.nsfw || false,
    },
    initialHydration: () => ({}),
};
